import { render, staticRenderFns } from "./ReceiverIcon.vue?vue&type=template&id=221ffae6&"
import script from "./ReceiverIcon.vue?vue&type=script&lang=js&"
export * from "./ReceiverIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports